'use client';
function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
import * as React from 'react';
import PropTypes from 'prop-types';
import useControlled from '@mui/utils/useControlled';
import { FormControlContext } from "./FormControlContext.js";
import { getFormControlUtilityClass } from "./formControlClasses.js";
import { useSlotProps } from "../utils/index.js";
import { unstable_composeClasses as composeClasses } from "../composeClasses/index.js";
import { useClassNamesOverride } from "../utils/ClassNameConfigurator.js";
import { jsx as _jsx } from "react/jsx-runtime";
function hasValue(value) {
    return value != null && !(Array.isArray(value) && value.length === 0) && value !== '';
}
function useUtilityClasses(ownerState) {
    var disabled = ownerState.disabled, error = ownerState.error, filled = ownerState.filled, focused = ownerState.focused, required = ownerState.required;
    var slots = {
        root: [
            'root',
            disabled && 'disabled',
            focused && 'focused',
            error && 'error',
            filled && 'filled',
            required && 'required'
        ]
    };
    return composeClasses(slots, useClassNamesOverride(getFormControlUtilityClass));
}
/**
 * Provides context such as filled/focused/error/required for form inputs.
 * Relying on the context provides high flexibility and ensures that the state always stays
 * consistent across the children of the `FormControl`.
 * This context is used by the following components:
 *
 * *   FormLabel
 * *   FormHelperText
 * *   Input
 * *   InputLabel
 *
 * You can find one composition example below and more going to [the demos](https://mui.com/material-ui/react-text-field/#components).
 *
 * ```jsx
 * <FormControl>
 *   <InputLabel htmlFor="my-input">Email address</InputLabel>
 *   <Input id="my-input" aria-describedby="my-helper-text" />
 *   <FormHelperText id="my-helper-text">We'll never share your email.</FormHelperText>
 * </FormControl>
 * ```
 *
 * ⚠️ Only one `Input` can be used within a FormControl because it create visual inconsistencies.
 * For instance, only one input can be focused at the same time, the state shouldn't be shared.
 *
 * Demos:
 *
 * - [Form Control](https://mui.com/base-ui/react-form-control/)
 * - [Input](https://mui.com/joy-ui/react-input/)
 * - [Checkbox](https://mui.com/material-ui/react-checkbox/)
 * - [Radio Group](https://mui.com/material-ui/react-radio-button/)
 * - [Switch](https://mui.com/material-ui/react-switch/)
 * - [Text Field](https://mui.com/material-ui/react-text-field/)
 *
 * API:
 *
 * - [FormControl API](https://mui.com/base-ui/react-form-control/components-api/#form-control)
 */ var FormControl = /*#__PURE__*/ React.forwardRef(function FormControl(props, forwardedRef) {
    var defaultValue = props.defaultValue, children = props.children, _props_disabled = props.disabled, disabled = _props_disabled === void 0 ? false : _props_disabled, _props_error = props.error, error = _props_error === void 0 ? false : _props_error, onChange = props.onChange, _props_required = props.required, required = _props_required === void 0 ? false : _props_required, _props_slotProps = props.slotProps, slotProps = _props_slotProps === void 0 ? {} : _props_slotProps, _props_slots = props.slots, slots = _props_slots === void 0 ? {} : _props_slots, incomingValue = props.value, other = _object_without_properties(props, [
        "defaultValue",
        "children",
        "disabled",
        "error",
        "onChange",
        "required",
        "slotProps",
        "slots",
        "value"
    ]);
    var _useControlled = _sliced_to_array(useControlled({
        controlled: incomingValue,
        default: defaultValue,
        name: 'FormControl',
        state: 'value'
    }), 2), value = _useControlled[0], setValue = _useControlled[1];
    var filled = hasValue(value);
    var _React_useState = _sliced_to_array(React.useState(false), 2), focusedState = _React_useState[0], setFocused = _React_useState[1];
    var focused = focusedState && !disabled;
    React.useEffect(function() {
        return setFocused(function(isFocused) {
            return disabled ? false : isFocused;
        });
    }, [
        disabled
    ]);
    var ownerState = _object_spread_props(_object_spread({}, props), {
        disabled: disabled,
        error: error,
        filled: filled,
        focused: focused,
        required: required
    });
    var childContext = React.useMemo(function() {
        return {
            disabled: disabled,
            error: error,
            filled: filled,
            focused: focused,
            onBlur: function() {
                setFocused(false);
            },
            onChange: function(event) {
                setValue(event.target.value);
                onChange === null || onChange === void 0 ? void 0 : onChange(event);
            },
            onFocus: function() {
                setFocused(true);
            },
            required: required,
            value: value !== null && value !== void 0 ? value : ''
        };
    }, [
        disabled,
        error,
        filled,
        focused,
        onChange,
        required,
        setValue,
        value
    ]);
    var classes = useUtilityClasses(ownerState);
    var renderChildren = function() {
        if (typeof children === 'function') {
            return children(childContext);
        }
        return children;
    };
    var _slots_root;
    var Root = (_slots_root = slots.root) !== null && _slots_root !== void 0 ? _slots_root : 'div';
    var rootProps = useSlotProps({
        elementType: Root,
        externalSlotProps: slotProps.root,
        externalForwardedProps: other,
        additionalProps: {
            ref: forwardedRef,
            children: renderChildren()
        },
        ownerState: ownerState,
        className: classes.root
    });
    return /*#__PURE__*/ _jsx(FormControlContext.Provider, {
        value: childContext,
        children: /*#__PURE__*/ _jsx(Root, _object_spread({}, rootProps))
    });
});
process.env.NODE_ENV !== "production" ? FormControl.propTypes = {
    // ┌────────────────────────────── Warning ──────────────────────────────┐
    // │ These PropTypes are generated from the TypeScript type definitions. │
    // │ To update them, edit the TypeScript types and run `pnpm proptypes`. │
    // └─────────────────────────────────────────────────────────────────────┘
    /**
   * The content of the component.
   */ children: PropTypes /* @typescript-to-proptypes-ignore */ .oneOfType([
        PropTypes.node,
        PropTypes.func
    ]),
    /**
   * Class name applied to the root element.
   */ className: PropTypes.string,
    /**
   * @ignore
   */ defaultValue: PropTypes.any,
    /**
   * If `true`, the label, input and helper text should be displayed in a disabled state.
   * @default false
   */ disabled: PropTypes.bool,
    /**
   * If `true`, the label is displayed in an error state.
   * @default false
   */ error: PropTypes.bool,
    /**
   * Callback fired when the form element's value is modified.
   */ onChange: PropTypes.func,
    /**
   * If `true`, the label will indicate that the `input` is required.
   * @default false
   */ required: PropTypes.bool,
    /**
   * The props used for each slot inside the FormControl.
   * @default {}
   */ slotProps: PropTypes.shape({
        root: PropTypes.oneOfType([
            PropTypes.func,
            PropTypes.object
        ])
    }),
    /**
   * The components used for each slot inside the FormControl.
   * Either a string to use a HTML element or a component.
   * @default {}
   */ slots: PropTypes.shape({
        root: PropTypes.elementType
    }),
    /**
   * The value of the form element.
   */ value: PropTypes.any
} : void 0;
export { FormControl };
